const NoRowsOverlay = (props) => {
  return <div className="ag-overlay-no-rows-center">{props.noRowsMessageFunc()}</div>;
};

export default NoRowsOverlay;
